module.exports = __webpack_public_path__ + "media/images/signatures/douglas_zuleta-274904bdd67ec8eebb6819443716fe19.jpeg";